import React, { Component } from 'react';
import { Paper, Table, TableHead, TableBody, TableRow, TableCell, 
        Button, Toolbar, Tooltip, Typography, Checkbox,
        Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress,
        FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Select, MenuItem, OutlinedInput} from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';
import PropTypes from 'prop-types';
//import debounce from 'lodash.debounce';

const styles = theme => ({
  root: {
    maxWidth: 1150,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flex: '1 1 100%',
  },
  title: {
    flex: '0 0 auto',
  },
  table: {
    minWidth: 1000,
  },
  updateDialog: {
    alignItems: 'center'
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  groupControl: {
    margin: theme.spacing.unit,
    minWidth: 200,
  },
  selectControl: {
    marginLeft: 8,
  },
  button: {
    margin: 0,
    padding: 0,
    fontSize: 14,
    width: 40,
  },
  menuItem: {
    float: 'left',
    display: 'block'
  },
  smallSelect: {
    alignItems: 'left',
    minWidth: 34,
    padding: '8px 16px 8px 8px'
  },
  phoneCell: {
    minWidth: 140,     // adjust as needed (140–160 is usually perfect)
    whiteSpace: 'nowrap',
  },
});

class UmpiresList extends Component {
  state = {
    isOpen: false,
    isUpdating: false,
    filters: {
      status: 'active',
      level: '',
      mentorship: 'all'
    },
  };

  componentDidMount() {
    const { getUmpiresList, fetchingUmpiresList, userSeason } = this.props;
    if (fetchingUmpiresList !== 'Loading' || fetchingUmpiresList !== 'Loaded') {
      getUmpiresList(userSeason);
    }
  }

  componentDidUpdate(prevProps){
    const { userSeason, getUmpiresList, umpires } = this.props;
    if (userSeason !== prevProps.userSeason) {
      getUmpiresList(userSeason);
    }
    if (umpires !== prevProps.umpires) {
      getUmpiresList(userSeason);
      this.setState({ isUpdating: false });
    }
  }

  handleCheckboxChange = event => {
    const { id, checked } = event.target;
    const [memberId, column] = id.split('-');

    //Provide feedback that Umpire data is updating
    this.setState({ isUpdating: true });

    switch (column) {
      case 'plate':
        this.props.updateUmp(memberId, null, checked, null, null, null, null, this.props.userSeason);
        return;
      case 'base':
        this.props.updateUmp(memberId, null, null, checked, null, null, null, this.props.userSeason);
        return;
      case 'mentor':
        this.props.updateUmp(memberId, null, null, null, checked, null, null, this.props.userSeason);
        return;
      case 'active':
        this.props.updateUmp(memberId, null, null, null, null, checked, null, this.props.userSeason);
        return;
      case 'youth':
        this.props.updateUmp(memberId, null, null, null, null, null, checked, this.props.userSeason);
        return;
      default:
        //Reset updating indicator if column not recognized
        this.setState({ isUpdating: false });
        return;
    }
  };

  handleUmpLevelChange = event => {
    const { name, value } = event.target;
    const [memberId] = name.split('-');
    //Provide feedback that Umpire data is updating
    this.setState({ isUpdating: true });
    this.props.updateUmp(memberId, value, null, null, null, null, this.props.userSeason);
  };

  handleFilterDialog = () => {
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  handleFilterChange = event => {
    this.setState( {
      filters: { ...this.state.filters, [event.target.name]: event.target.value }});
  };

  render() {
    const { umpiresSeason, umpiresSeasonList, userSeason } = this.props;
    const { classes } = this.props;
    const { filters } = this.state;
    let renderUmp = false;

    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div  className={classes.title}>
            <Typography variant="h5">
              Umpire Table
            </Typography>
          </div>
          <div className={classes.spacer} />
          <div>
            <Tooltip id="tooltip-umpfilter" disableFocusListener={true} title="Filter Umpires">
              <Button
                className={classes.button}
                variant="contained" size="small" color="primary"
                onClick={this.handleFilterDialog}
              >
                <FilterList />
              </Button>
            </Tooltip>
          </div>
        </Toolbar>
        <Dialog className={classes.updateDialog} open={this.state.isUpdating}>
          <div>
            <CircularProgress className={classes.progress}/>
          </div>
        </Dialog>
        <Dialog
            open={this.state.isOpen}
            onClose={this.handleClose}
        >
            <DialogTitle>Filter Umpires</DialogTitle>
            <DialogContent>
              <FormControlLabel
                className={classes.selectControl}
                label={<Typography variant="body1">Umpire Level: </Typography>}
                labelPlacement="start"
                control={
                  <Select
                    classes={{select: classes.smallSelect}}
                    value={this.state.filters.level}
                    name="level"
                    input={
                      <OutlinedInput
                        labelWidth={0}
                      />
                    }
                    onChange={this.handleFilterChange}
                  >
                    <MenuItem className={classes.menuItem} value=""><em>All</em></MenuItem>
                    {[1,2,3,4,5,6,7].map(i => {
                        return(<MenuItem key={`level-${i}`} className={classes.menuItem} value={i}>{i}</MenuItem>)
                    })}
                  </Select>}
                />
            </DialogContent>
            <DialogContent>
              <FormControl className={classes.groupControl}>
                <FormLabel >Mentorship</FormLabel>
                <RadioGroup
                  name="mentorship"
                  value={this.state.filters.mentorship}
                  onChange={this.handleFilterChange}
                >
                  <FormControlLabel value="all" control={<Radio color="primary"/>} label="All" />
                  <FormControlLabel value="mentor" control={<Radio color="primary"/>} label="Mentors" />
                  <FormControlLabel value="mentee" control={<Radio color="primary"/>} label="Mentees" />
                </RadioGroup>
              </FormControl>
              <FormControl className={classes.groupControl}>
                <FormLabel >Status</FormLabel>
                <RadioGroup
                  name="status"
                  value={this.state.filters.status}
                  onChange={this.handleFilterChange}
                >
                  <FormControlLabel value="all" control={<Radio color="primary"/>} label="All" />
                  <FormControlLabel value="active" control={<Radio color="primary"/>} label="Active" />
                  <FormControlLabel value="inactive" control={<Radio color="primary"/>} label="Inactive" />
                </RadioGroup>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button className={classes.button}
                variant="contained" size="small" color="primary"
                onClick={this.handleClose}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        <Table className={classes.table} padding="dense">
            <TableHead>
              <TableRow>
                <TableCell ><Typography variant="body1">ID</Typography></TableCell>
                <TableCell ><Typography variant="body1">Name</Typography></TableCell>
                <TableCell className={classes.phoneCell}><Typography variant="body1">Phone Number</Typography></TableCell>
                <TableCell align="center"><Typography variant="body1">Level</Typography></TableCell>
                <TableCell padding="none" align="center"><Typography variant="body1">Plate</Typography></TableCell>
                <TableCell padding="none" align="center"><Typography variant="body1">Base</Typography></TableCell>
                <TableCell padding="none" align="center"><Typography variant="body1">Mentor</Typography></TableCell>
                <TableCell align="center"><Typography variant="body1">@Plate</Typography></TableCell>
                <TableCell align="center"><Typography variant="body1">@Base</Typography></TableCell>
                <TableCell align="center"><Typography variant="body1">Active</Typography></TableCell>
                <TableCell align="center"><Typography variant="body1">Youth</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {umpiresSeasonList.map((umpId, index) => {
                renderUmp = false;
                const isActive = umpiresSeason[umpId] ? umpiresSeason[umpId].isActive : false;
                const isMentor = umpiresSeason[umpId][userSeason] ? umpiresSeason[umpId][userSeason].isMentor : false;
                const umpireLevel = umpiresSeason[umpId][userSeason] ? umpiresSeason[umpId][userSeason].umpireLevel  : 0;
                const isPlate = umpiresSeason[umpId] ? umpiresSeason[umpId].plateUmpire : false;
                const isBase = umpiresSeason[umpId] ? umpiresSeason[umpId].baseUmpire : false;
                const isYouth = umpiresSeason[umpId].isYouth ? umpiresSeason[umpId].isYouth : false;

                //const umpireExists = umpiresSeason[umpId][userSeason] !== null ? true : false;
                const base1 = umpiresSeason[umpId][userSeason]  ? umpiresSeason[umpId][userSeason].umpBase1Total : 0;
                const base2 = umpiresSeason[umpId][userSeason]  ? umpiresSeason[umpId][userSeason].umpBase3Total : 0;
                const base3 = umpiresSeason[umpId][userSeason]  ? umpiresSeason[umpId][userSeason].umpBase2Total : 0;
                const plateTotal = umpiresSeason[umpId][userSeason]  ? umpiresSeason[umpId][userSeason].umpPlateTotal : 0;
                let umpBaseTotal = base1 + base2 + base3;

                if (((filters.level === '') || (filters.level === umpireLevel)) &&
                    ((filters.mentorship === 'all') || ((filters.mentorship === 'mentor') && isMentor) || ((filters.mentorship === 'mentee') && !isMentor)) &&
                    ((filters.status === 'all') || ((filters.status === 'active') && isActive) || ((filters.status === 'inactive') && !isActive)))
                {
                  renderUmp = true;
                }
                if (renderUmp) {
                  return (
                    <TableRow key={umpiresSeason[umpId].memberId} hover>
                      <TableCell ><Typography variant="body1">{umpiresSeason[umpId].memberId}</Typography></TableCell>
                      <TableCell ><Typography variant="body1">
                        {umpiresSeason[umpId].firstName} {umpiresSeason[umpId].lastName}
                      </Typography></TableCell>
                      <TableCell ><Typography variant="body1">{umpiresSeason[umpId].phoneNumber}</Typography></TableCell>
                      <TableCell align="center">
                        <FormControl>
                          <Select
                            classes={{select: classes.smallSelect}}
                            value={umpireLevel}
                            onChange={this.handleUmpLevelChange}
                            input={
                              <OutlinedInput
                                labelWidth={0}
                              />
                            }
                            inputProps={{
                              name: `${umpiresSeason[umpId].memberId}-level`,
                              id: `${umpiresSeason[umpId].memberId}-level`,
                            }}
                          >
                            <MenuItem className={classes.menuItem} value={0}>0</MenuItem>
                            <MenuItem className={classes.menuItem} value={1}>1</MenuItem>
                            <MenuItem className={classes.menuItem} value={2}>2</MenuItem>
                            <MenuItem className={classes.menuItem} value={3}>3</MenuItem>
                            <MenuItem className={classes.menuItem} value={4}>4</MenuItem>
                            <MenuItem className={classes.menuItem} value={5}>5</MenuItem>
                            <MenuItem className={classes.menuItem} value={6}>6</MenuItem>
                            <MenuItem className={classes.menuItem} value={7}>7</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell padding="none" align="center">
                        <FormControl>
                          <Checkbox
                            checked={isPlate}
                            onChange={this.handleCheckboxChange}
                            id={`${umpiresSeason[umpId].memberId}-plate`}
                            color="primary"
                          />         
                        </FormControl>                
                      </TableCell>
                      <TableCell padding="none" align="center">
                        <FormControl>
                          <Checkbox
                            checked={isBase}
                            onChange={this.handleCheckboxChange}
                            id={`${umpiresSeason[umpId].memberId}-base`}
                            color="primary"
                          />         
                        </FormControl>                
                      </TableCell>
                      <TableCell padding="none" align="center">
                        <FormControl>
                          <Checkbox
                            checked={isMentor}
                            onChange={this.handleCheckboxChange}
                            id={`${umpiresSeason[umpId].memberId}-mentor`}
                            color="primary"
                          />         
                        </FormControl>                
                      </TableCell>
                      <TableCell align="center"><Typography variant="body1">{plateTotal}</Typography></TableCell>
                      <TableCell align="center"><Typography variant="body1">{umpBaseTotal}</Typography></TableCell>
                      <TableCell align="center">
                        <FormControl>
                          <Checkbox
                            checked={isActive}
                            onChange={this.handleCheckboxChange}
                            id={`${umpiresSeason[umpId].memberId}-active`}
                            color="primary"
                          />         
                        </FormControl>                
                      </TableCell>
                      <TableCell align="center">
                        <FormControl>
                          <Checkbox
                            checked={isYouth}
                            onChange={this.handleCheckboxChange}
                            id={`${umpiresSeason[umpId].memberId}-youth`}
                            color="primary"
                          />         
                        </FormControl>                
                      </TableCell>
                    </TableRow>
                  );
                }
                return(null);
              })}
            </TableBody>
          </Table>
      </Paper>
    );
  }
}

UmpiresList.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(UmpiresList);



// WEBPACK FOOTER //
// ./src/components/UmpiresListV2.js